import React from "react";
import Navbar from "./navbar";
import ServiceHeroSection from "./ServiceHeroSection";
import Footer from "./Footer";
import StatsCounter from "./StatsCounter";
import { Smartphone, Shield, Rocket, BarChart3, Zap, CheckCircle } from "lucide-react";
import WhyCustom from "./WhyCustom";
import KeyConsideration from "./KeyConsideration";
import DevelopmentProcess from "./DevelopmentProcess";
import TechStackk from "./AppTechStack";
import CallToAction from "./CallToAction";

const PhoneUI = () => (
  <div className="relative flex items-center justify-center w-full h-full py-10">
    {/* Glow */}
    <div className="absolute w-72 h-72 rounded-full bg-violet-600/20 blur-3xl" />

    {/* Phone */}
    <div className="relative z-10 w-[260px] h-[520px] rounded-[45px] border border-white/20 bg-white/5 backdrop-blur-xl shadow-[0_0_60px_rgba(109,40,217,.35)]">
      <div className="absolute top-5 left-1/2 -translate-x-1/2 w-14 h-1 rounded-full bg-gray-400" />
      <div className="absolute top-4 left-10 w-2 h-2 rounded-full bg-gray-400" />

      <div className="mt-12 mx-4 h-24 rounded-3xl bg-gradient-to-br from-violet-700 to-violet-500 flex items-center justify-center shadow-lg">
        <Smartphone className="text-white" size={32} />
      </div>

      <div className="px-5 mt-5 space-y-3">
        <div className="h-2 rounded-full bg-white/10"><div className="h-full w-[78%] rounded-full bg-cyan-400" /></div>
        <div className="h-2 rounded-full bg-white/10"><div className="h-full w-[56%] rounded-full bg-violet-500" /></div>
        <div className="h-2 rounded-full bg-white/10"><div className="h-full w-[88%] rounded-full bg-fuchsia-500" /></div>
      </div>

      <div className="grid grid-cols-2 gap-2 px-5 mt-5">
        {[[BarChart3, "Analytics"], [Rocket, "Deploy"], [Shield, "Secure"], [Zap, "Fast"]].map(([Icon, label]) => (
          <div key={label} className="flex items-center justify-center gap-2 py-2 rounded-xl bg-white/5 border border-white/10 text-gray-300 text-xs">
            <Icon size={14} />{label}
          </div>
        ))}
      </div>

      <div className="absolute bottom-8 left-5 right-5">
        <button className="w-full py-3 rounded-2xl font-semibold text-white text-sm bg-gradient-to-r from-violet-600 via-indigo-500 to-cyan-400 shadow-[0_0_20px_rgba(59,130,246,.4)] hover:scale-105 duration-300">
          Launch App →
        </button>
      </div>
    </div>

    {/* Badges */}
    <div className="absolute top-16 right-4 px-4 py-2 rounded-full bg-gradient-to-r from-violet-700 to-indigo-500 text-white text-xs shadow-xl flex items-center gap-2">
      <CheckCircle className="text-green-400" size={14} /> iOS & Android
    </div>
    <div className="absolute bottom-28 left-2 px-4 py-2 rounded-full bg-cyan-500/20 border border-cyan-400/40 text-cyan-300 text-xs flex items-center gap-2">
      <Zap size={14} /> 60fps Smooth
    </div>
    <div className="absolute bottom-44 right-2 px-4 py-2 rounded-full bg-violet-500/20 border border-violet-400/40 text-violet-300 text-xs flex items-center gap-2">
      <Shield size={14} /> Secure
    </div>
  </div>
);

export default function AppServicePage() {
  return (
    <div className="min-h-screen bg-white overflow-x-clip">
      <Navbar />
      <ServiceHeroSection
        badge="Mobile App Development"
        title={(
          <>
            <span className="bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
              Custom Mobile App
            </span>
            <br /> Development
          </>
        )}
        description="From concept to launch, we create intuitive iOS and Android applications that engage users, streamline operations, and scale with your business."
        media={<PhoneUI />}
      />
      <StatsCounter />
      <WhyCustom />
      <KeyConsideration />
      <DevelopmentProcess />
      <TechStackk />
      <CallToAction />
      <Footer />
    </div>
  );
}
